export enum ModeratorPermission {
  Admin = 'admin',
  Moderator = 'moderator',
}
